import { useMemo } from 'react';
import { useJWT } from 'src/app/common/utils';
import { AdminWalletPermissionType } from '../../../constants';

export const useWalletAwardPermission = () => {
  const jwt = useJWT() || {};
  const permissions: string[] = jwt?.permissions ? Object.keys(jwt.permissions) : [];
  const result = useMemo(() => {
    const hasAny = (targets: AdminWalletPermissionType[]) =>
      permissions.some((p) => targets.includes(p as AdminWalletPermissionType));

    return {
      updatePermission: hasAny([AdminWalletPermissionType.WALLET_AWARD_UPDATE]),
      createPermission: hasAny([AdminWalletPermissionType.WALLET_AWARD_CREATE]),
      approvePermission: hasAny([AdminWalletPermissionType.WALLET_AWARD_APPROVE]),
      viewAssignedPermission: hasAny([AdminWalletPermissionType.WALLET_ASSIGNED_AWARD_READ]),
    };
  }, [permissions]);

  return result;
};
